// extracted by mini-css-extract-plugin
module.exports =  {"footer":"da51a739f7--footer--h3zNq","logo":"da51a739f7--logo--yaKxM","description":"da51a739f7--description--Yt0Rg","bottom":"da51a739f7--bottom--lkoS6"};